import React, {useState} from 'react'
import {Grid, Input, Segment, Icon, Label, Form, List, Header, Table} from "semantic-ui-react";
import Axios from "axios";
import objDefault from '../../../models/patientsVisit'
import moment from "moment";
import {register} from "../../../serviceWorker";
import  Constants from "../../../config/constants";
import {DateInput} from "semantic-ui-calendar-react";
const options = [
    {key: 'm', text: 'ชาย', value: 'M'},
    {key: 'f', text: 'หญิง', value: 'F'}
]
const PatientVisit = () => {
    const [input, setInput] = useState({
        ...objDefault

    });

    const [users, setUsers] = useState([]);
    const [user, setUser] = useState({});
    const [visit, setVisit] = useState({});
    const [visits, setVisits] = useState([]);

    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;

        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
    };

    const getUserById = async (user) => {
        try {
            let response = await Axios.get('http://'+Constants.url+':'+Constants.port+'/v1/snr/patient?id=' + user.id);
            let response_visit = await Axios.get('http://'+Constants.url+':'+Constants.port+'/v1/snr/visit?id=' + user.id);
            setVisits(response_visit.data.data);

            response = response.data.data[0]
            setInput((prevInput) => ({
                ...prevInput,
                name: response.name,
                surname: response.surname,
                address: response.address,
                citizen_id: response.citizen_id,
                gender: response.gender,
                telephone:response.telephone,
                email : response.email,
                blood_group : response.blood_group,
                rh : response.rh,
                remark : response.remark,
                hn : response.hn,
                id : response.id,
                patient_id : response.id
            }))

        } catch (e) {
            console.log(e);
        }
    }

    const getVisitById = async  (visit) => {
        try {
            let response = await Axios.get('http://'+Constants.url+':'+Constants.port+'/v1/snr/visit?visit_id=' + visit.id);
            response = response.data.data[0]

            setInput((prevInput) => ({
                ...prevInput,
                name: response.name,
                surname: response.surname,
                weight: response.weight,
                height: response.height,
                hr: response.hr,
                rr:response.rr,
                sat : response.sat,
                bp : response.bp,
                bt : response.bt,
                other : response.other,
                register_date : response.register_date,
                patient_id : response.patient_id,
                visit_id : visit.id
            }))
        }catch (e) {
            console.log(e);
        }
    }

    const search = async (e) => {
        try {
            const {
                name, value
            } = e.target;
            setInput((prevInput) => ({
                ...prevInput,
                [name]: value,
            }))

            let res = await Axios.get('http://'+Constants.url+':'+Constants.port+'/v1/snr/patient?search='+input.search);
            setUsers(res.data.data);
        } catch (e) {
            console.log(e);
        }
    }

    const saveVisit = async () => {
        try {
            let result = await Axios.post('http://'+Constants.url+':'+Constants.port+'/v1/snr/visit',
                {
                    patient_id : input.patient_id,
                    register_date: input.register_date,
                    hr: input.hr,
                    rr: input.rr,
                    bp: input.bp,
                    bt: input.bt,
                    sat: input.sat,
                    other : input.other,
                    height : input.height,
                    weight : input.weight,
                    visit_id : input.visit_id
                }
            );
            alert(result.data.message)
        } catch (e) {
            console.log(e)
        }
    }
    return (
        <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>

            <div style={{flex: 1}}>
                <Grid style={{marginTop: "5em", marginLeft: "2em"}}>
                    <Grid.Row>
                        <Grid.Column width={3}>
                            <Label>
                                <Icon name='user'/> ค้นหา HN , ชื่อ , บัตรประชาชน
                            </Label>
                            <Input
                                style={{display: 'flex'}}
                                name={"search"}
                                onChange={(e) => search(e)}
                                placeholder=' HN , ชื่อ , บัตรประชาชน'
                                value={input.search}
                                icon='search'
                            />

                            <List divided relaxed>
                                {
                                   users.length > 0  ? users.map(user => (
                                        <List.Item>
                                            <List.Icon name='user circle icon' size='large' verticalAlign='middle' />
                                            <List.Content
                                                onClick={(e) => getUserById(user)}
                                                key={user.id}
                                            >
                                                <List.Header as='a'>{user.name}</List.Header>
                                                <List.Description as='a'>register date {moment(user.created_date).format("DD-MM-YYYY")}</List.Description>
                                            </List.Content>
                                        </List.Item>
                                   )) :  <List.Item> <List.Content><List.Header as='a'>ไม่พบข้อมูล</List.Header></List.Content></List.Item>
                                }
                            </List>


                        </Grid.Column>
                        <Grid.Column width={12}>
                            <Segment>
                                <Header as='h3' block>
                                    HN {input.hn} ชื่อ {input.name} {input.surname} เพศ {input.gender} หมู่เลือด {input.blood_group} RH {input.rh}
                                </Header>
                                <Form>
                                    <Form.Group widths='equal'>
                                        <DateInput
                                            name="register_date"
                                            placeholder="Date"
                                            required={'true'}
                                            value={input.register_date}
                                            label='วันที่ลงทะเบียน'
                                            iconPosition="right"
                                            onChange={(e, {name, value})=>handleValueChange({target:{name, value}})}
                                        />


                                        <Form.Input required={'true'} fluid label='น้ำหนัก' name='weight' value={input.weight}
                                                    placeholder='น้ำหนัก'   onChange={(e)=>handleValueChange(e)}
                                        />

                                        <Form.Input required={'true'}  fluid label='ส่วนสูง' name='height' value={input.height}
                                                    placeholder='ส่วนสูง'    onChange={(e)=>handleValueChange(e)}
                                        />
                                        <Form.Input  fluid label='HR' name='hr' value={input.hr}
                                                    placeholder='HR'    onChange={(e)=>handleValueChange(e)}
                                        />
                                        <Form.Input  fluid label='RR' name='rr' value={input.rr}
                                                    placeholder='RR'    onChange={(e)=>handleValueChange(e)}
                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>


                                        <Form.Input fluid label='BP (mm.Hg.)' name='bp' value={input.bp}
                                                    placeholder='BP (mm.Hg.)'  onChange={(e)=>handleValueChange(e)}/>
                                        <Form.Input fluid label='BT (c.)' name='bt' value={input.bt}
                                                    placeholder='BT'  onChange={(e)=>handleValueChange(e)}/>
                                        <Form.Input fluid label='SAT (%)' name='sat' value={input.sat}
                                                    placeholder='SAT'  onChange={(e)=>handleValueChange(e)}/>
                                    </Form.Group>
                                    <Form.TextArea label='remark'  placeholder='หมายเหตุ' name='other'
                                                   value={input.other}  onChange={(e)=>handleValueChange(e)}/>
                                    <Form.Button primary
                                                 onClick={() => saveVisit()}
                                    >Submit</Form.Button>
                                </Form>

                            </Segment>

                            <Segment secondary color='teal'>
                                <Header as='h3' dividing>
                                    ประวัติ visit
                                </Header>
                                <Table singleLine   >
                                    <Table.Header >
                                        <Table.Row>
                                            <Table.HeaderCell  style={{backgroundColor:'grey'}}>วันที่รับการรักษา</Table.HeaderCell>
                                            <Table.HeaderCell  style={{backgroundColor:'grey'}}>นน/ส่วนสูง</Table.HeaderCell>
                                            <Table.HeaderCell  style={{backgroundColor:'grey'}}>อายุ</Table.HeaderCell>
                                            <Table.HeaderCell  style={{backgroundColor:'grey'}}>HR</Table.HeaderCell>
                                            <Table.HeaderCell  style={{backgroundColor:'grey'}}>PR</Table.HeaderCell>
                                            <Table.HeaderCell  style={{backgroundColor:'grey'}}>BP (mm.Hg.)</Table.HeaderCell>
                                            <Table.HeaderCell  style={{backgroundColor:'grey'}}>BT (c.)</Table.HeaderCell>
                                            <Table.HeaderCell  style={{backgroundColor:'grey'}}>SAT (%)</Table.HeaderCell>
                                            <Table.HeaderCell style={{backgroundColor:'grey'}}>หมายเหตุ</Table.HeaderCell>
                                            <Table.HeaderCell style={{backgroundColor:'grey'}}>ดำเนินการ</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        {
                                            visits.map(visit => (
                                        <Table.Row>
                                            <Table.Cell>{moment(visit.register_date).format("DD-MM-YYYY")}</Table.Cell>
                                            <Table.Cell>{visit.weight}/{visit.height}</Table.Cell>
                                            <Table.Cell>24</Table.Cell>
                                            <Table.Cell>{visit.hr}</Table.Cell>
                                            <Table.Cell>{visit.rr}</Table.Cell>
                                            <Table.Cell>{visit.bp}</Table.Cell>
                                            <Table.Cell>{visit.bt}</Table.Cell>
                                            <Table.Cell>{visit.sat}</Table.Cell>
                                            <Table.Cell>{visit.other}</Table.Cell>
                                            <Table.Cell style={{cursor: 'pointer'}} >


                                                <Icon name='edit'   onClick={(e) => getVisitById(visit)}
                                                      key={visit.id} />


                                            </Table.Cell>

                                        </Table.Row>
                                            ))
                                        }


                                    </Table.Body>
                                </Table>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>

                </Grid>

            </div>

        </div>
    );
}

export default PatientVisit;
